import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30da9c42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProfileCertifications" }
const _hoisted_2 = { class: "ProfileCertifications__Title Profile__h2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 64 64" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-certification" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 64 64" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-certification" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 64 64" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-certification" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('profile.certifications')), 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oldCertifications, (certification, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: 'profile-old-certification-'+index,
          class: _normalizeClass(["ProfileCertifications__Item", 'ProfileCertifications__Item--' + certification.label])
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(certification.label), 1)
        ], 2))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile?.certifications, (certification, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: 'profile-certification-'+index,
          class: _normalizeClass(["ProfileCertifications__Item", 'ProfileCertifications__Item--' + certification.category])
        }, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('profile.certificationLabel_'+certification.category)), 1)
        ], 2))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practicalCertifications, (certification, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: 'profile-old-certification-'+index,
          class: _normalizeClass(["ProfileCertifications__Item", 'ProfileCertifications__Item--' + certification.label])
        }, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(certification.label), 1)
        ], 2))
      }), 128))
    ])
  ]))
}